module.exports = __webpack_public_path__ + "static/media/class_job_011.d5e7676a.svg";